export var Identifiers;
(function (Identifiers) {
    Identifiers["IMAGE_ID"] = "ghl-image-editor-base-image";
    Identifiers["CROP_LAYER_ID"] = "ghl-image-editor-crop-layer";
    Identifiers["IMAGE_LAYER_ID"] = "ghl-image-editor-image-layer";
    Identifiers["TEXT_ID_PREFIX"] = "ghl-image-editor-text-node--";
    Identifiers["CROP_BOX"] = "ghl-image-editor-crop-box";
    Identifiers["CROP_BOX_TRANSFORMER"] = "ghl-image-editor-crop-box-transformer";
    Identifiers["GROUP_OBJECT_ID"] = "ghl-image-editor-group-object-id";
    Identifiers["TEXT_TRANSFORMER"] = "ghl-image-editor-text-transformer";
    Identifiers["STICKER_TRANSFORMER"] = "ghl-image-editor-sticker-transformer";
    Identifiers["STICKER_ID_PREFIX"] = "ghl-image-editor-sticker-node--";
    Identifiers["BRUSH_ID_PREFIX"] = "ghl-image-editor-brush-node--";
    Identifiers["CURSOR_IMAGE_ID"] = "ghl-image-editor-cursor-image";
    Identifiers["BRUSH_TRANSFORMER"] = "ghl-image-editor-brush-transformer";
})(Identifiers || (Identifiers = {}));
